import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth/auth.service';
import { ImpersonationService } from '../../shared/services/impersonation.service';
import { Observable } from 'rxjs';
import { IApiUserAuthenticated } from 'src/app/shared/interfaces/IApiUserAuthenticated';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private impersonationService: ImpersonationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.log('🔍 AuthGuard: Validando acceso a:', state.url);

    // Validar el estado de la sesión
    const sessionValid = this.authService.validateSessionState();
    
    if (!sessionValid) {
      console.log('🚨 AuthGuard: Sesión inválida - redirigiendo a login');
      this.router.navigate(['/login-form'], {
        queryParams: { returnUrl: state.url }
      });
      return false;
    }

    const user: IApiUserAuthenticated | null = this.authService.getUser;
    const isAuthForm = [
      'login-form',
      'reset-password',
      'create-account',
      'change-password/:recoveryCode'
    ].includes(route.routeConfig?.path || '/');

    if (!!user && user.JwtToken) {
      // Verificar si hay estado de impersonalización corrupto
      if (this.impersonationService.isImpersonating()) {
        const originalUser = this.impersonationService.getOriginalUser();
        
        if (!originalUser) {
          console.log('🚨 AuthGuard: Impersonalización corrupta detectada - limpiando');
          this.impersonationService.forceRestoreOriginalUser();
          
          // Si no se puede restaurar, redirigir a login
          if (!this.authService.getUser) {
            this.router.navigate(['/login-form'], {
              queryParams: { returnUrl: state.url }
            });
            return false;
          }
        } else {
          console.log('✅ AuthGuard: Estado de impersonalización válido');
        }
      }

      console.log('✅ AuthGuard: Usuario autenticado correctamente');
      return true;
    } else {
      console.log('🚨 AuthGuard: Usuario no autenticado - redirigiendo a login');
      this.router.navigate(['/login-form'], {
        queryParams: { returnUrl: state.url }
      });
      return false;
    }
  }
}
